import { defineComponent as g, useSlots as C, ref as v, computed as u } from "vue";
import { NcButton as h, NcIconSvgWrapper as N, NcModal as b } from "@nextcloud/vue";
import { useElementSize as y } from "@vueuse/core";
const S = g({ __name: "DialogButton", props: { callback: null, label: null, icon: null, type: null }, emits: ["click"], setup(e, { emit: t }) {
  const a = e;
  return { __sfc: !0, props: a, emit: t, handleClick: (o) => {
    var s;
    (s = a.callback) == null || s.call(a), t("click", o);
  }, NcButton: h, NcIconSvgWrapper: N };
} });
function m(e, t, a, o, s, r, c, p) {
  var n = typeof e == "function" ? e.options : e;
  t && (n.render = t, n.staticRenderFns = a, n._compiled = !0), o && (n.functional = !0), r && (n._scopeId = "data-v-" + r);
  var l;
  if (c ? (l = function(i) {
    i = i || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !i && typeof __VUE_SSR_CONTEXT__ < "u" && (i = __VUE_SSR_CONTEXT__), s && s.call(this, i), i && i._registeredComponents && i._registeredComponents.add(c);
  }, n._ssrRegister = l) : s && (l = p ? function() {
    s.call(this, (n.functional ? this.parent : this).$root.$options.shadowRoot);
  } : s), l)
    if (n.functional) {
      n._injectStyles = l;
      var d = n.render;
      n.render = function(i, f) {
        return l.call(f), d(i, f);
      };
    } else {
      var _ = n.beforeCreate;
      n.beforeCreate = _ ? [].concat(_, l) : [l];
    }
  return { exports: e, options: n };
}
var k = function() {
  var e = this, t = e._self._c, a = e._self._setupProxy;
  return t(a.NcButton, { attrs: { "aria-label": a.props.label, type: a.props.type }, on: { click: a.handleClick }, scopedSlots: e._u([a.props.icon !== void 0 ? { key: "icon", fn: function() {
    return [typeof a.props.icon == "string" ? t(a.NcIconSvgWrapper, { attrs: { svg: a.props.icon } }) : t(a.props.icon, { tag: "component", attrs: { size: 20 } })];
  }, proxy: !0 } : null], null, !0) }, [e._v(" " + e._s(a.props.label) + " ")]);
}, x = [], w = m(S, k, x, !1, null, null, null, null);
const B = w.exports, E = g({ __name: "DialogBase", props: { name: null, message: { default: "" }, additionalTrapElements: { default: () => [] }, container: { default: void 0 }, size: { default: "small" }, buttons: { default: () => [] }, navigationClasses: { default: () => [] }, contentClasses: { default: () => [] }, dialogClasses: { default: () => [] } }, emits: ["close"], setup(e, { emit: t }) {
  const a = e, o = C(), s = v(), { width: r } = y(s), c = u(() => r.value < 876), p = u(() => (o == null ? void 0 : o.navigation) !== void 0), n = v(!0), l = () => {
    n.value = !1, t("close");
  }, d = u(() => ({ additionalTrapElements: a.additionalTrapElements, container: a.container === void 0 ? "body" : a.container, name: a.name, size: a.size, enableSlideshow: !1, enableSwipe: !1 }));
  return { __sfc: !0, props: a, emit: t, slots: o, wrapper: s, dialogWidth: r, isNavigationCollapsed: c, hasNavigation: p, open: n, handleClose: l, modalProps: d, NcModal: b, DialogButton: B };
} });
var T = function() {
  var e = this, t = e._self._c, a = e._self._setupProxy;
  return a.open ? t(a.NcModal, e._b({ staticClass: "dialog__modal", on: { close: a.handleClose } }, "NcModal", a.modalProps, !1), [t("h2", { staticClass: "dialog__name", domProps: { textContent: e._s(e.name) } }), t("div", { staticClass: "dialog", class: e.dialogClasses }, [t("div", { ref: "wrapper", class: ["dialog__wrapper", { "dialog__wrapper--collapsed": a.isNavigationCollapsed }] }, [a.hasNavigation ? t("nav", { staticClass: "dialog__navigation", class: e.navigationClasses }, [e._t("navigation", null, { isCollapsed: a.isNavigationCollapsed })], 2) : e._e(), t("div", { staticClass: "dialog__content", class: e.contentClasses }, [e._t("default", function() {
    return [t("p", [e._v(e._s(a.props.message))])];
  })], 2)]), t("div", { staticClass: "dialog__actions" }, [e._t("actions", function() {
    return e._l(a.props.buttons, function(o, s) {
      return t(a.DialogButton, e._b({ key: s, on: { click: a.handleClose } }, "DialogButton", o, !1));
    });
  })], 2)])]) : e._e();
}, D = [], $ = m(E, T, D, !1, null, "a37caee5", null, null);
const I = $.exports;
export {
  I as D,
  m as n
};
